import React, { useState } from "react";
import { useHistory } from "react-router";
import { PlanService } from "../../Services";
import Loader from "../../Components/Loader";
import { FiPlusCircle, FiCheckSquare, FiTrash2 } from "react-icons/fi";

export const EditAddon = (props) => {
  const history = useHistory();
  const [loader, setLoader] = useState(false);
  const stateData = history.location.state || {};
  
  const [formData, setFormData] = useState({
    id: stateData._id || "",
    name: stateData.name || "",
    type_name: stateData.type_name || "",
    description: stateData.description || "",
    price: stateData.price || 0,
    yearly_price: stateData.yearly_price != null ? stateData.yearly_price : "",
    duration: stateData.duration || "Monthly",
    credits: stateData.credits || 0,
    yearly_credits: stateData.yearly_credits != null ? stateData.yearly_credits : "",
    extra_users: stateData.extra_users || 0,
    yearly_extra_users: stateData.yearly_extra_users != null ? stateData.yearly_extra_users : "",
    module: stateData.module || "general",
    features: stateData.features || [],
    yearly_features: stateData.yearly_features || []
  });

  const [newFeature, setNewFeature] = useState("");
  const [newYearlyFeature, setNewYearlyFeature] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleAddFeature = (field, value, clear) => {
    if (value.trim()) {
      setFormData(prev => ({ ...prev, [field]: [...prev[field], value.trim()] }));
      clear("");
    }
  };

  const handleRemoveFeature = (field, index) => {
    setFormData(prev => {
      const next = [...prev[field]];
      next.splice(index, 1);
      return { ...prev, [field]: next };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);
    PlanService.updateAddon(formData).then((res) => {
      setLoader(false);
      if (res.status) {
        history.push("/plan-list"); // Redirect back to plans tab
      } else {
        alert(res.message || "Failed to update addon");
      }
    }).catch((err) => {
      setLoader(false);
      alert("Error updating addon");
    });
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <form onSubmit={handleSubmit}>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4 className="card-title mb-0" style={{ fontSize: '1.4rem', fontWeight: 'bold' }}>Edit Add-on</h4>
            <div>
              <button type="button" className="btn btn-outline-secondary me-2" onClick={() => history.push("/plan-list")}>Cancel</button>
              <button type="submit" className="btn btn-success shadow-sm" style={{ fontWeight: '600' }}>Update Add-on</button>
            </div>
          </div>

          <div className="row">
            {/* Left Column */}
            <div className="col-lg-8">
              {/* Basic Details Card */}
              <div className="card shadow-sm border-0 mb-4">
                <div className="card-header bg-white border-bottom-0 pt-4 pb-0">
                  <h5 className="mb-0 text-primary d-flex align-items-center">
                    <FiPlusCircle className="me-2" /> Addon Details & Pricing
                  </h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label text-muted fw-bold">Addon Name</label>
                      <input type="text" className="form-control bg-light border-0" name="name" value={formData.name} onChange={handleChange} placeholder="e.g. Extra 5,000 API Calls" required />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label text-muted fw-bold">Type Name</label>
                      <input type="text" className="form-control bg-light border-0" name="type_name" value={formData.type_name} onChange={handleChange} placeholder="e.g. API Booster" />
                    </div>
                    <div className="col-md-12 mb-3">
                      <label className="form-label text-muted fw-bold">Description</label>
                      <textarea className="form-control bg-light border-0" name="description" rows="2" value={formData.description} onChange={handleChange} placeholder="Provides additional API calls..."></textarea>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label text-muted fw-bold">Monthly price</label>
                      <div className="input-group">
                        <span className="input-group-text bg-light border-0">$</span>
                        <input type="number" className="form-control bg-light border-0" name="price" value={formData.price} onChange={handleChange} required />
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label text-muted fw-bold">Yearly price</label>
                      <div className="input-group">
                        <span className="input-group-text bg-light border-0">$</span>
                        <input type="number" className="form-control bg-light border-0" name="yearly_price" value={formData.yearly_price} onChange={handleChange} placeholder="Charged when Yearly is selected" />
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label text-muted fw-bold">Monthly credits</label>
                      <input type="number" className="form-control bg-light border-0" name="credits" value={formData.credits} onChange={handleChange} required />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label text-muted fw-bold">Yearly credits</label>
                      <input type="number" className="form-control bg-light border-0" name="yearly_credits" value={formData.yearly_credits} onChange={handleChange} placeholder="Credits granted on a yearly plan" />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label text-muted fw-bold">Monthly extra users</label>
                      <input type="number" min="0" className="form-control bg-light border-0" name="extra_users" value={formData.extra_users} onChange={handleChange} />
                      <small className="text-muted">Seats added after a monthly purchase. User-seat add-ons stay on the Users page.</small>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label text-muted fw-bold">Yearly extra users</label>
                      <input type="number" min="0" className="form-control bg-light border-0" name="yearly_extra_users" value={formData.yearly_extra_users} onChange={handleChange} />
                      <small className="text-muted">Leave empty to use the monthly seat count.</small>
                    </div>
                    <div className="col-md-12 mb-3">
                      <label className="form-label text-muted fw-bold">Show on</label>
                      <select className="form-select bg-light border-0" name="module" value={Number(formData.extra_users) > 0 || Number(formData.yearly_extra_users) > 0 ? "users" : formData.module} onChange={handleChange}>
                        <option value="general">Plan cards</option>
                        <option value="users">Users page only</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              {/* Core Features Card */}
              <div className="card shadow-sm border-0 mb-4">
                <div className="card-header bg-white border-bottom-0 pt-4 pb-0">
                  <h5 className="mb-0 text-primary d-flex align-items-center">
                    <FiCheckSquare className="me-2" /> Monthly features
                  </h5>
                </div>
                <div className="card-body">
                  <div className="d-flex mb-3">
                    <input type="text" className="form-control me-2" placeholder="e.g. 500 Credits" value={newFeature} onChange={(e) => setNewFeature(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), handleAddFeature('features', newFeature, setNewFeature))} />
                    <button type="button" className="btn btn-primary" onClick={() => handleAddFeature('features', newFeature, setNewFeature)}>Add Feature</button>
                  </div>
                  <ul className="list-group list-group-flush">
                    {formData.features.map((feature, index) => (
                      <li key={index} className="list-group-item d-flex justify-content-between align-items-center px-0">
                        <span><FiCheckSquare className="text-success me-2" /> {feature}</span>
                        <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => handleRemoveFeature('features', index)}>
                          <FiTrash2 />
                        </button>
                      </li>
                    ))}
                    {formData.features.length === 0 && <li className="list-group-item text-muted px-0 border-0">No monthly features added yet.</li>}
                  </ul>
                </div>
              </div>

              <div className="card shadow-sm border-0 mb-4">
                <div className="card-header bg-white border-bottom-0 pt-4 pb-0">
                  <h5 className="mb-0 text-primary d-flex align-items-center">
                    <FiCheckSquare className="me-2" /> Yearly features
                  </h5>
                </div>
                <div className="card-body">
                  <p className="text-muted small">Shown when Yearly is selected. Leave empty to keep the monthly features.</p>
                  <div className="d-flex mb-3">
                    <input type="text" className="form-control me-2" placeholder="e.g. 6,000 Credits" value={newYearlyFeature} onChange={(e) => setNewYearlyFeature(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), handleAddFeature('yearly_features', newYearlyFeature, setNewYearlyFeature))} />
                    <button type="button" className="btn btn-primary" onClick={() => handleAddFeature('yearly_features', newYearlyFeature, setNewYearlyFeature)}>Add Feature</button>
                  </div>
                  <ul className="list-group list-group-flush">
                    {formData.yearly_features.map((feature, index) => (
                      <li key={index} className="list-group-item d-flex justify-content-between align-items-center px-0">
                        <span><FiCheckSquare className="text-success me-2" /> {feature}</span>
                        <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => handleRemoveFeature('yearly_features', index)}>
                          <FiTrash2 />
                        </button>
                      </li>
                    ))}
                    {formData.yearly_features.length === 0 && <li className="list-group-item text-muted px-0 border-0">No yearly features added yet.</li>}
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </form>
        <Loader isShow={loader} />
      </div>
    </div>
  );
};
